<template>
  <div>
    <p style="font-size: 16px; line-height: 17px" class="mb-5">
      ※ [<b>{{ $t("위험성평가") }}</b
      >{{ $t("(유해·위험요인 파악) →") }}<b>{{ $t("위험성평가회의") }}</b
      >{{ $t("(위험성평가의 공유) →") }}<b>{{ $t("교육·TBM 전파") }}</b
      >{{ $t("(위험성 결정, 감소대책 수립) →") }}<b>{{ $t("이행확인") }}</b
      >{{ $t("(감소대책 실행)]") }}
    </p>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" :options="[{ type: 'text', value: '공정명', label: '공정명' }]" />

    <!-- 위험성평가 -->
    <RiskTable v-model="form.riskList" class="mb-6" :is-print="isPrint" />

    <!-- ➆ 위험성 결정, 감소대책 수립 및 실행계획 확인 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      :title="$t('➆ 위험성 결정, 감소대책 수립 및 실행계획 확인')"
      :controls="false"
      :multiple="false"
      :tableData="[
        { id: 'target', title: $t('소속명'), type: 'text', placeholder: $t('내용') },
        { id: 'position', title: $t('직급'), type: 'text', placeholder: $t('내용') },
        { id: 'type', title: $t('직책'), type: 'text', placeholder: $t('내용') },
        { id: 'name', title: $t('이름'), type: 'text', placeholder: $t('내용') },
        { id: 'sign', title: $t('서명'), type: 'sign' },
      ]"
      :mobile="['target', 'name']"
      v-model="form.managerList"
    />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";
import RiskTable from "./RiskTable.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import FileUploader from "@/components/FileUploader";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    TableCustom,
    RiskTable,
    DateSelector,
    FileUploader,
  },
  props: {
    isPrint: Boolean,
    header: Object,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      headerDate: { required },
      stdInfo: {
        field_name: { required },
      },
      // inputA_1: { required },
      // inputA_2: { required },
      // inputA_3: { required },
      // inputA_4: { required },
      // inputA_5: { required },
      // inputA_6: { required },

      riskList: { required, minLength: minLength(1) },
    },
  },
  computed: {
    isPostId() {
      return !!this.$route.params.postId;
    },
  },
  watch: {
    header: {
      immediate: true,
      deep: true,
      handler(value) {
        const year = value.year;
        const month = Number(`${value.month}`);
        this.form.headerDate = `${year}-${month < 10 ? `0${month}` : month}`;
      },
    },
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        value.riskDisaster = value.riskList.map((item) => item.input4).join(", ");
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        headerDate: "",
        stdInfo: {},
        fileList: [],
        riskDisaster: "",
        riskList: [],
        managerList: [
          { id: 1, type: "" },
          { id: 2, type: "" },
          { id: 3, type: "" },
          { id: 4, type: "" },
        ],

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: {},
        inputA_6: "",
      },
      workRank: ["감독관", "현장 대리인", "현장소장", "부장", "차장", "과장", "대리", "계장", "주임", "협력업체"],
    };
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.headerDate.required) return "날짜는 반드시 선택해야 합니다";
        if (!this.$v.form.stdInfo.field_name.required) return "회사명을 반드시 입력해야 합니다";
        // if (!this.$v.form.inputA_1.required) return "작업내용을 반드시 입력해야 합니다";
        // if (!this.$v.form.inputA_2.required) return "평가일을 반드시 입력해야 합니다";
        // if (!this.$v.form.inputA_3.required) return "관리기간을 반드시 입력해야 합니다";
        // if (!this.$v.form.inputA_4.required) return "관리기간을 반드시 입력해야 합니다";
        // if (!this.$v.form.inputA_5.required) return "예정공정표를 반드시 첨부해야 합니다";
        // if (!this.$v.form.inputA_6.required) return "예정공정 현황을 반드시 입력해야 합니다";
        if (!this.$v.form.riskList.required) return "위험성평가 항목을 한개이상 입력해야 합니다";
      }
    },
    translationMap() {
      const prefix = "위험성평가(3등급).3등급(상·중·하) 판단법";

      const translateData = {
        [`${prefix}.기본정보.회사명`]: this.form.stdInfo.field_name,
        [`${prefix}.기본정보.작성자이름`]: this.form.stdInfo.writer_name,
        [`${prefix}.기본정보.작성일`]: this.form.stdInfo.date,
        [`${prefix}.기본정보.공정명`]: this.form.stdInfo.공정명,

        [`${prefix}.위험성평가표`]: this.form.riskList.map((item) => {
          return {
            "공종분류": item.input1,
            "단위작업": item.input2,
            "위험요인": item.input3,
            "재해형태": item.input4,
            "위험성 결정.위험도 등급": item.input5,
            "위험방지대책": item.input6,
            "개선조치 담당자": item.input7,
            "개선조치 조치예정일": item.input8,
            "이행확인.근로자대표": item.input9,
            "이행확인.관리감독자": item.input10,
          }
        }),

        [`${prefix}.위험성 결정, 감소대책 수립 및 실행계획 확인`]: this.form.managerList.map((item) => {
          return {
            "소속명": item.target,
            "직급": item.position,
            "직책": item.type,
            "이름": item.name,
          }
        }),

      };

      return translateData;
    },
    translate(translate) {
      const prefix = "위험성평가(3등급).3등급(상·중·하) 판단법";

      this.form.stdInfo.field_name = translate[`${prefix}.기본정보.회사명`];
      this.form.stdInfo.writer_name = translate[`${prefix}.기본정보.작성자이름`];
      this.form.stdInfo.date = translate[`${prefix}.기본정보.작성일`];
      this.form.stdInfo.공정명= translate[`${prefix}.기본정보.공정명`];

      const riskList = translate[`${prefix}.위험성평가표`];
      const _riskList = JSON.parse(JSON.stringify(this.form.riskList));
      for (let i=0; i<riskList.length; i++) {
        _riskList[i].input1 = riskList[i]['공종분류'];
        _riskList[i].input2 = riskList[i]['단위작업'];
        _riskList[i].input3 = riskList[i]['위험요인'];
        _riskList[i].input4 = riskList[i]['재해형태'];
        _riskList[i].input5 = riskList[i]['위험성 결정.위험도 등급'];
        _riskList[i].input6 = riskList[i]['위험방지대책'];
        _riskList[i].input7 = riskList[i]['개선조치 담당자'];
        _riskList[i].input8 = riskList[i]['개선조치 조치예정일'];
        _riskList[i].input9 = riskList[i]['이행확인.근로자대표'];
        _riskList[i].input10 = riskList[i]['이행확인.관리감독자'];
      }
      this.$set(this.form, "riskList", _riskList);

      const managerList = translate[`${prefix}.위험성 결정, 감소대책 수립 및 실행계획 확인`];
      const _managerList = JSON.parse(JSON.stringify(this.form.managerList));
      for (let i=0; i<managerList.length; i++) {
        _managerList[i].target = managerList[i]['소속명'];
        _managerList[i].position = managerList[i]['직급'];
        _managerList[i].type = managerList[i]['직책'];
        _managerList[i].name = managerList[i]['이름'];
      }
      this.$set(this.form, "managerList", _managerList);
    },
  },
};
</script>

<style scoped lang="scss">
.header-month::v-deep {
  input {
    background: white;
  }
  &.readonly input {
    background: #fafafa !important;
  }
}
</style>
